var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget widget-item-list widget-primary" }, [
    _c("div", { staticClass: "widget-inner" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.loadcarousel
            ? [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _vm.fullItems.length === 0
                      ? [
                          _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(4, function(n) {
                              return _c(
                                "div",
                                { staticClass: "col-6 col-lg-3" },
                                [_vm._m(0, true)]
                              )
                            }),
                            0
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "carousel",
                      { attrs: { "items-per-page": 4 } },
                      [
                        _vm._l(_vm.fullItems, function(item) {
                          return _c(
                            "template",
                            { slot: "items" },
                            [
                              _c("category-item", {
                                key: item.id,
                                attrs: {
                                  loggedin: _vm.loggedin,
                                  incategory: 1,
                                  wishlist: _vm.wishlist,
                                  itemdocument: item,
                                  "item-data": item.data,
                                  "decimal-count":
                                    _vm.$ceres.config.item.storeSpecial,
                                  "disable-carousel-on-mobile": false
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  2
                )
              ]
            : [
                _vm.fullItems.length === 0
                  ? _vm._l(_vm.count, function(n) {
                      return _c("div", { staticClass: "col-6 col-lg-3" }, [
                        _vm._m(1, true)
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.fullItems, function(item) {
                  return _c(
                    "div",
                    { staticClass: "col-6 col-lg-3" },
                    [
                      _c("category-item", {
                        key: item.id,
                        attrs: {
                          loggedin: _vm.loggedin,
                          incategory: 1,
                          wishlist: _vm.wishlist,
                          itemdocument: item,
                          "item-data": item.data,
                          "decimal-count": _vm.$ceres.config.item.storeSpecial,
                          "disable-carousel-on-mobile": false
                        }
                      })
                    ],
                    1
                  )
                })
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "article",
      { staticClass: "cmp cmp-product-thumb cmp-product-thumb--grid" },
      [
        _c("div", { staticClass: "article-inner" }, [
          _c("div", { staticClass: "article-inner-image" }, [
            _c("a", [
              _c("img", {
                staticClass: "skelet-cat-image",
                attrs: {
                  src:
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "article-inner-always" }, [
            _c("div", { staticClass: "d-flex split" }, [
              _c("div", { staticClass: "prices" }, [
                _c("div", { staticClass: "price" }, [
                  _c("span", { staticClass: "price-n skelet-price" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
                      }
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "name skelet-name" }, [
              _c("img", {
                attrs: {
                  src:
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
                }
              })
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "article",
      { staticClass: "cmp cmp-product-thumb cmp-product-thumb--grid" },
      [
        _c("div", { staticClass: "article-inner" }, [
          _c("div", { staticClass: "article-inner-image" }, [
            _c("a", [
              _c("img", {
                staticClass: "skelet-cat-image",
                attrs: {
                  src:
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "article-inner-always" }, [
            _c("div", { staticClass: "d-flex split" }, [
              _c("div", { staticClass: "prices" }, [
                _c("div", { staticClass: "price" }, [
                  _c("span", { staticClass: "price-n skelet-price" }, [
                    _c("img", {
                      attrs: {
                        src:
                          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
                      }
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "name skelet-name" }, [
              _c("img", {
                attrs: {
                  src:
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
                }
              })
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }